export function NotFound() {
  return <div className="flex-1 flex justify-content-center align-items-center bold font-24">404 Not Found</div>;
}
